import { render, staticRenderFns } from "./SalesOrderInvoicesPanel.vue?vue&type=template&id=2f93652e&scoped=true"
import script from "./SalesOrderInvoicesPanel.vue?vue&type=script&lang=js"
export * from "./SalesOrderInvoicesPanel.vue?vue&type=script&lang=js"
import style0 from "./SalesOrderInvoicesPanel.vue?vue&type=style&index=0&id=2f93652e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f93652e",
  null
  
)

export default component.exports